<template>

    <div>

        <div class="w-full p-6 mt-2 flex flex-col">

            <h2 class="text-theme-discrete font-bold text-xl p-6">{{ translate('up-section-myinfo') }}</h2>

            <form class="w-full p-6" method="POST" action="">

                {{ token }}

                @csrf

                <div class="flex flex-wrap mb-6">
                    <label for="name" class="block text-theme-main text-sm font-bold mb-2">
                        {{ __('register-names') }}:
                    </label>

                    <input id="name" type="text" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner @error('name')  border-red-500 @enderror" name="name" value="" required autocomplete="name">

                    @error('name')
                    <p class="text-red-500 text-xs italic mt-4">
                        {{ $message }}
                    </p>
                    @enderror
                </div>


                <div class="flex flex-wrap mb-6">
                    <label for="email" class="block text-theme-main text-sm font-bold mb-2">
                        {{ __('email-address') }}:
                    </label>

                    <input id="email" type="email" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner @error('email') border-red-500 @enderror" name="email" value="" required autocomplete="email">

                    @error('email')
                    <p class="text-red-500 text-xs italic mt-4">
                        {{ $message }}
                    </p>
                    @enderror
                </div>

                <div class="flex flex-wrap mb-6">
                    <label for="password" class="block text-theme-main text-sm font-bold mb-2">
                        {{ __('your-password') }}:
                    </label>

                    <input id="password" type="password" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner @error('password') border-red-500 @enderror" name="password" required autocomplete="new-password">

                    @error('password')
                    <p class="text-red-500 text-xs italic mt-4">
                        {{ $message }}
                    </p>
                    @enderror

                    <p class="text-xs text-theme-main mt-2">Leave blank to keep your current password</p>

                </div>


                <div class="flex flex-wrap mb-6">
                    <label for="password-confirm" class="block text-theme-main text-sm font-bold mb-2">
                        {{ __('register-password-confirm') }}:
                    </label>

                    <input id="password-confirm" type="password" class="bg-theme-level3 text-theme-inputs form-input border-theme-level2 w-full focus:outline-none focus:border-theme-level2 shadow-inner " name="password_confirmation" required autocomplete="new-password">
                </div>


                <div class="flex flex-wrap items-center mt-16">

                    <button type="submit" class="bg-theme-controls3 hover:bg-theme-controls2 text-theme-control-label font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline">
                        Update
                    </button>
                    <button type="button" class="ml-1 bg-theme-level1 hover:bg-theme-controls2 text-theme-discrete hover:text-theme-control-label font-bold py-2 px-4 rounded focus:outline-none focus:shadow-outline" onclick="window.location='/login'">
                        {{ __('cancel') }}
                    </button>

                </div>

            </form>

        </div>

    </div>

</template>

<script>

    const Lang = require('lang.js');
    import translations from './messages.js';

    const lang = new Lang();

    lang.setMessages(translations);

    export default {

        data() {

            return {

            }

        },

        props: [

            'user'

        ],

        methods: {

            translate(key) {
                key = 'strings.' + key;
                return lang.get(key);
            },

        }

    }

</script>
